<script setup>
import { router, useForm } from '@inertiajs/vue3';
import JetButton from '@/Jetstream/Button.vue';
import JetFormSection from '@/Jetstream/FormSection.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetInputError from '@/Jetstream/InputError.vue';
import JetLabel from '@/Jetstream/Label.vue';

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

const form = useForm({
    name: '',
});

const createTeam = () => {
    form.post(route(urlNamePrefix+'teams.store'), {
        errorBag: 'createTeam',
        preserveScroll: true,
    });
};



</script>

<template>
    <JetFormSection @submitted="createTeam">
        <template #title>
            {{ $t('team.create.details') }}
        </template>

        <template #description>
            {{ $t('team.create.description') }}
        </template>

        <template #form>
            <div class="col-span-6">
                <JetLabel value="Team Owner" />

                <div class="flex items-center mt-2">
                    <img class="object-cover w-12 h-12 rounded-full" :src="$page.props.auth.user.profile_photo_url" :alt="$page.props.auth.user.first_name + ' ' + $page.props.auth.user.last_name">

                    <div class="ml-4 leading-tight">
                        <div>{{ $page.props.auth.user.first_name }} {{ $page.props.auth.user.last_name }}</div>
                        <div class="text-sm text-gray-700">
                            {{ $page.props.auth.user.email }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-span-6 sm:col-span-4">
                <JetLabel for="name" value="Team Name" />
                <JetInput
                    id="name"
                    v-model="form.name"
                    type="text"
                    class="block w-full mt-1"
                    autofocus
                />
                <JetInputError :message="form.errors.name" class="mt-2" />
            </div>
        </template>

        <template #actions>
            <JetButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                {{ $t('team.create.create') }}
            </JetButton>
        </template>
    </JetFormSection>
</template>
